// SPDX-License-Identifier: LicenseRef-Techsafe-Proprietary
// Copyright (c) 2026 Techsafe Teknoloji ve Muhendislik A.S.
// https://techsafe-solutions.com
// Economic rights: Techsafe A.S.
// Authors' moral rights reserved under Turkish Copyright Law (FSEK 5846).
// Mali haklar Techsafe A.S.'ye aittir; eser sahiplerinin manevi haklari saklidir (FSEK 5846).
// DRAFT AI-assistance notice (IP, License & Attribution Policy v1.3 §12d-1):
// This content was prepared with the assistance of AI tools and is, on this
// branch, a DRAFT pending human review. On the human-approved merge of its
// Merge Request this notice flips to the published variant (§12d-2).
// Bu icerik yapay zeka destekli araclarla hazirlanmis bir TASLAKTIR (§12d-1);
// insan onayiyla birlestirilmesinde yayimlanmis surumune (§12d-2) donusur.

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { createRealGatewayClient } from "./bridge/gateway-client-factory";
import type { PollParams } from "./bridge/rendezvous";
import type { BridgeTransport } from "./bridge/types";
import { createZohoTransport } from "./bridge/zoho-transport";
import "./styles/globals.css";

// ── Transport wiring ─────────────────────────────────────────────────────────
// Build the real Zoho Creator bridge transport using the Gateway postMessage
// channel + shared-record rendezvous (ADR-002 P1–P6). The per-tier Gateway
// origin is resolved from the build/runtime environment inside
// createRealGatewayClient (never hardcoded here), so this composition root only
// wires the client, the bounded poll parameters, and the transport.
//
// To run against the in-repo mock (no Gateway, no ZC), swap:
//   import { createMockTransport } from "./contracts/mock-transport";
//   const transport: BridgeTransport = createMockTransport();

const client = createRealGatewayClient();

const poll: PollParams = {
  intervalMs: 500,
  maxAttempts: 60, // 30 s total
  sleep: (ms) => new Promise((resolve) => setTimeout(resolve, ms)),
};

const transport: BridgeTransport = createZohoTransport({ client, poll });

const container = document.getElementById("au0009-root");
if (!container) {
  throw new Error("AU0009 widget: mount node #au0009-root not found.");
}

createRoot(container).render(
  <StrictMode>
    <App transport={transport} />
  </StrictMode>,
);
